import 'angular:locale/data:en';
import 'angular:locale/data:de';
import './apps/decision-tool/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
